<swiper *ngIf="slides" [config]="config">
  <ng-template swiperSlide *ngFor="let slide of slides">
    <img [src]="slide.fileUrl" *ngIf="!slide.isVideo" />
    <video *ngIf="slide.isVideo" autoplay muted loop preload #video>
      <source [src]="slide.fileUrl" [type]="slide.contentType" />
    </video>
  </ng-template>
</swiper>
